var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_2693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00035 9.15139C6.57494 9.15139 6.14954 9.01185 5.78667 8.72907L0.412109 4.54992V10.3867C0.412109 11.0687 0.965161 11.622 1.6474 11.622H12.3533C13.0355 11.622 13.5886 11.0689 13.5886 10.3867V4.54992L8.21505 8.7319C7.85219 9.01242 7.42498 9.15139 7.00035 9.15139ZM0.831337 3.8319L6.29237 8.0808C6.70902 8.40507 7.2927 8.40507 7.70935 8.0808L13.1704 3.8319C13.411 3.62602 13.5886 3.30948 13.5886 2.97492C13.5886 2.29268 13.0353 1.73962 12.3533 1.73962H1.6474C0.965161 1.73962 0.412109 2.29268 0.412109 2.97492C0.412109 3.30948 0.566779 3.62602 0.831337 3.8319Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_2693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1765,
    height: 13.1765,
    fill: "white",
    transform: "translate(0.412109 0.0925293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEmail);
export default __webpack_public_path__ + "static/media/footerEmail.ffef7ea2158307d3098f1ab32169ae05.svg";
export { ForwardRef as ReactComponent };